/**
 * Format ISO date as "Nov 20, 2025"
 */
export const formatDate = (isoString) => {
  if (!isoString) return '';
  
  try {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  } catch (err) {
    return isoString;
  }
};

/**
 * Format date range as "Nov 25–27, 2025"
 */
export const formatDateRange = (startIso, endIso) => {
  if (!startIso || !endIso) return formatDate(startIso || endIso);
  
  try {
    const start = new Date(startIso);
    const end = new Date(endIso);
    
    const startMonth = start.toLocaleDateString('en-US', { month: 'short' });
    const startDay = start.getDate();
    const endDay = end.getDate();
    const year = start.getFullYear();
    
    // Same month and year
    if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
      return `${startMonth} ${startDay}–${endDay}, ${year}`;
    }
    
    // Different months
    return `${formatDate(startIso)} – ${formatDate(endIso)}`;
  } catch (err) {
    return `${startIso} – ${endIso}`;
  }
};

/**
 * Format ISO datetime as "Nov 20, 2025 at 3:45 PM"
 */
export const formatDateTime = (isoString) => {
  if (!isoString) return '';
  
  try {
    const date = new Date(isoString);
    const dateStr = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
    const timeStr = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit'
    });
    return `${dateStr} at ${timeStr}`;
  } catch (err) {
    return isoString;
  }
};
